<template>
  <div id="rodape" class="px-2 align-center font-weight-medium">
    <template>
      <div class="quadrado bg-red-300" />
      <p>
        Pedidos por Exportar Manualmente
        <v-icon small @click="dialogItensPosExportar = true">mdi-help-circle</v-icon>
      </p>
    </template>

    <v-spacer />

    <p>Total de Itens: {{items.length}}</p>

    <sys-dialog
      v-model="dialogItensPosExportar"
      ocultar-acoes
      titulo="Pedidos por Exportar Manualmente"
    >
      <div class="pb-5">
        <p class="font-13px">Esta ação é necessaria porque o robô do Systock já tentou exportar o pedido varias vezes e não obteve sucesso.</p>
        <p class="font-13px mt-2">Verique com seu TI se a API interna de exportação está funcionando.</p>
        <p class="font-13px mt-2">Para mais informações entre em contato com suporte Systock.</p>
      </div>
    </sys-dialog>
  </div>
</template>

<script>
import SysDialog from "../../../padraoDeLayout/SysDialog";
export default {
  name: "RodapeListaDePedidos",
  components: {SysDialog},
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    dialogItensPosExportar: false
  })
}
</script>

<style scoped>
#rodape {
  border-top: 1px solid rgba(213, 213, 213, 0.96);
  border-bottom: 1px solid rgba(213, 213, 213, 0.96);
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
p {
  margin: 0;
  font-size: 12px;
}
.quadrado {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.font-13px {
  font-size: 13px;
}
</style>
